import Icon from 'components/atoms/Icon';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import styles from './ProjectLink.module.scss';

type Props = {
  projectName: string;
  projectCompanyName?: string;
  projectPath: string;
};

const ProjectLink: FC<Props> = ({
  projectPath,
  projectName,
  projectCompanyName,
}) => (
  <Link to={projectPath}>
    <div className={styles['content']} data-testid="project-link">
      <Icon icon="left_arrow" className={styles['icon']} />
      Roles / {projectCompanyName} / {projectName}
    </div>
  </Link>
);

export default ProjectLink;
